import React, { useEffect, useState } from "react";
import { Row, Col, Card, message } from "antd";
import ReactECharts from "echarts-for-react";
import { subItemHooks } from "../hooks";

const DashBoardLayout = () => {
  const [dauData, setDauData] = useState([
    { date: "2024-12-01", dau: 3 },
    { date: "2024-12-02", dau: 4 },
    { date: "2024-12-03", dau: 2 },
    { date: "2024-12-04", dau: 5 },
    { date: "2024-12-05", dau: 3 },
    { date: "2024-12-06", dau: 6 },
    { date: "2024-12-07", dau: 7 },
    { date: "2024-12-08", dau: 8 },
    { date: "2024-12-09", dau: 6 },
    { date: "2024-12-10", dau: 5 },
    { date: "2024-12-11", dau: 4 },
    { date: "2024-12-12", dau: 3 },
    { date: "2024-12-13", dau: 2 },
    { date: "2024-12-14", dau: 1 },
  ]);

  const [mauData, setMauData] = useState([
    { month: "2024-07", mau: 10 },
    { month: "2024-08", mau: 12 },
    { month: "2024-09", mau: 14 },
    { month: "2024-10", mau: 16 },
    { month: "2024-11", mau: 18 },
    { month: "2024-12", mau: 20 },
  ]);
  const [ctrData, setCtrData] = useState([]);
  const fetchData = async () => {
    try {
      const res = await subItemHooks.globalIndicators();
      processDau(res.data.traffic.dau);
      processMau(res.data.traffic.mau);
      processCtr(res.data.traffic.ctr);
    } catch (error) {
      message.error("DAU 데이터를 불러오는 데 실패했습니다.");
    }
  };
  const processDau = (dauData) => {
    const today = new Date();
    const startDate = new Date();
    startDate.setDate(today.getDate() - 13);
    const allDates = generateDates(startDate, today);
    const dauMap = Object.fromEntries(
      dauData.map((item) => [item.date, item.dau])
    );
    const filledDauData = allDates.map((date) => ({
      date,
      dau: dauMap[date] || 0,
    }));
    setDauData(filledDauData);
  };
  const processMau = (mauData) => {
    const currentMonth = new Date();
    const startMonth = new Date();
    startMonth.setMonth(currentMonth.getMonth() - 5);

    const allMonths = generateMonths(startMonth, currentMonth);
    const mauMap = Object.fromEntries(
      mauData.map((item) => [item.month, item.mau])
    );
    const filledMauData = allMonths.map((month) => ({
      month,
      mau: mauMap[month] || 0,
    }));

    setMauData(filledMauData);
  };
  const generateDates = (start, end) => {
    const dates = [];
    let current = new Date(start);
    while (current <= end) {
      dates.push(current.toISOString().split("T")[0]);
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  const generateMonths = (start, end) => {
    const months = [];
    let current = new Date(start);
    while (current <= end) {
      months.push(current.toISOString().slice(0, 7));
      current.setMonth(current.getMonth() + 1);
    }
    return months;
  };
  const processCtr = async (ctrData) => {
    console.log("ctr", ctrData);
    const allDays = Array.from(
      new Set(
        ctrData.flatMap((item) => JSON.parse(item.days)) // JSON 문자열을 배열로 변환
      )
    ).sort();

    const filledData = ctrData.map((item) => {
      const days = JSON.parse(item.days); // JSON 문자열을 배열로 변환
      const ctr = JSON.parse(item.ctr); // JSON 문자열을 배열로 변환
      const dayCtrMap = Object.fromEntries(
        days.map((day, index) => [day, ctr[index]])
      );
      const filledCtr = allDays.map((day) => dayCtrMap[day] || 0);
      return {
        product: item.product,
        days: allDays,
        ctr: filledCtr,
      };
    });

    setCtrData(filledData);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // DAU 옵션 구성
  const getDAUOptions = () => {
    const dates = dauData.map((item) => item.date);
    const dauValues = dauData.map((item) => item.dau);

    return {
      title: {
        text: "DAU (Daily Active Users)",
        left: "center",
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      xAxis: {
        type: "category",
        data: dates,
        axisLabel: {
          rotate: 45,
        },
      },
      yAxis: {
        type: "value",
        name: "Users",
      },
      series: [
        {
          name: "DAU",
          type: "bar",
          data: dauValues,
          itemStyle: {
            color: "#1890ff",
          },
        },
      ],
    };
  };

  // MAU 옵션 구성
  const getMAUOptions = () => {
    const months = mauData.map((item) => item.month);
    const mauValues = mauData.map((item) => item.mau);

    return {
      title: {
        text: "MAU (Monthly Active Users)",
        left: "center",
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      xAxis: {
        type: "category",
        data: months,
        axisLabel: {
          rotate: 45,
        },
      },
      yAxis: {
        type: "value",
        name: "Users",
      },
      series: [
        {
          name: "MAU",
          type: "line",
          data: mauValues,
          itemStyle: {
            color: "#ff4d4f",
          },
        },
      ],
    };
  };
  // CTR 옵션 구성
  const getCTROptions = () => {
    return {
      title: {
        text: "상품별 CTR (Click Through Rate)",
        left: "center",
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "line",
        },
      },
      legend: {
        top: "bottom",
      },
      xAxis: {
        type: "category",
        data: ctrData[0]?.days || [],
      },
      yAxis: {
        type: "value",
        name: "CTR",
        axisLabel: {
          formatter: "{value}(클릭수)",
        },
      },
      series: ctrData.map((product) => ({
        name: product.product,
        type: "line",
        data: product.ctr.map((value) => value), // 퍼센트로 변환
      })),
    };
  };

  return (
    <div style={{ padding: "20px" }}>
      <Row gutter={[16, 16]}>
        {/* DAU 차트 */}
        <Col xs={24} md={12}>
          <Card>
            <ReactECharts
              option={getDAUOptions()}
              style={{ height: "400px" }}
            />
          </Card>
        </Col>

        {/* MAU 차트 */}
        <Col xs={24} md={12}>
          <Card>
            <ReactECharts
              option={getMAUOptions()}
              style={{ height: "400px" }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
        <Col span={24}>
          <Card>
            <ReactECharts
              option={getCTROptions()}
              style={{ height: "500px" }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DashBoardLayout;
